import { id } from './../../../../tools/src/lib/types/primitives';
import { makeAutoObservable } from 'mobx';

export interface ITargetCid {
	current_cid?: id;
	new_cid?: id;
}

export interface ICidReplaceSegment {
	current_cid: id;
	new_cid: id;
}

export interface ICidReplaceForm {
	target_cid: id;
	segments: ICidReplaceSegment[];
}

export interface ICid {
	current_cid?: id;
	target_cid?: id;
	segmentRows?: TargetCidModel[];
}

export type ICidCreateForm = ICidReplaceForm;

export type ICidEditForm = ICidReplaceForm;

export class TargetCidModel implements ITargetCid {
	current_cid?: id;
	new_cid?: id;

	constructor(props?: ITargetCid) {
		this.current_cid = props?.current_cid;
		this.new_cid = props?.new_cid;
		makeAutoObservable(this);
	}

	public getCurrentTargetCid(): id | undefined {
		return this.current_cid;
	}

	public setCurrentTargetCid(current_cid: id) {
		this.current_cid = current_cid;
	}

	public getNewTargetCid(): id | undefined {
		return this.new_cid;
	}

	public setNewTargetCid(new_cid: id) {
		this.new_cid = new_cid;
	}
}

export class CidModel implements ICid {
	current_cid?: id;
	target_cid?: id;
	segmentRows: TargetCidModel[];

	constructor(props?: ICid) {
		this.current_cid = props?.current_cid;
		this.target_cid = props?.target_cid;
		this.segmentRows = props?.segmentRows || [];
		makeAutoObservable(this);
	}

	getId(): id | undefined {
		return this.current_cid;
	}

	public getCurrentCid(): id | undefined {
		return this.current_cid;
	}

	public setCurrentCid(current_cid: id) {
		this.current_cid = current_cid;
		this.target_cid = undefined;
		this.segmentRows = [];
	}

	public getTargetCid(): id | undefined {
		return this.target_cid;
	}

	public setTargetCid(target_cid: id) {
		this.target_cid = target_cid;
	}

	public setSegmentRows(rows: TargetCidModel[]) {
		this.segmentRows = rows;
	}

	public getSegmentRows(): TargetCidModel[] {
		return this.segmentRows;
	}
}
